// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



export const environment = {
'GLOBAL_AUTH': 'TEST_VALUE',
'APPLICATION':'CONSOLE',
'VERSION':'v1',
'API_URL':'https://api.demohandler.in/api',
'API_URL_NEW':'https://api.demohandler.in/api/v1/admin/',
'DOMAIN':'https://api.demohandler.in',
'RAZORPAY_KEY_ID':'rzp_test_Rkp1Rm8aI8wDkH',
'WEB_URL':'https://safure.demohandler.in/',
'ADDRESS_API_KEY':'25d261a6a2cc45deb0954b14270ac706'

};
